import { render, staticRenderFns } from "./PaginationHeader.vue?vue&type=template&id=5547b685"
import script from "./PaginationHeader.vue?vue&type=script&lang=ts"
export * from "./PaginationHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports